import { h } from 'preact'
import ButtonControl from '../../button-control'
import Modal from '../../../components/reactModal'
import Table from '../../table/Table'
import RadioInputGroup from '../../ui-components/RadioInputGroup'
import { IdeaStatus } from '../interfaces'
import Tooltip from '../../ui-components/Tooltip'
import Icon from '../../assets'

interface Props {
  isOpen: boolean,
  isIdeaStatusMappingSetup: boolean,
  showError: boolean,
  onClose: () => void,
  onSave: () => void,
  onChangeCallback: (item: IdeaStatus, status: string) => void,
  list: Array<IdeaStatus>
}

export const IdeaStatusMappingModal = ({ isIdeaStatusMappingSetup, isOpen, list, onClose, onSave, onChangeCallback, showError } : Props) => {
  const modalTitle = !isIdeaStatusMappingSetup ? 'Set up the product feedback dashboard' : 'Ideation status mapping'
  const modalDescription = 'In order to view your product feedback performance, please map your ideation statuses to 3 types.'
  const model = [
    { header: 'Ideation status', accessor: 'status', size: 's' },
    { header: <div>Open<Tooltip position='center' trigger={<Icon icon='question' width={16} height={16} customClass='icon-info' />}
      customClasses='idea-status-help-tooltip'
      tooltipMessage={`Ideation statuses that indicate an idea hasn't been delivered yet (e.g. New, Planned).`} /> </div>,
    accessor: 'open',
    size: 'xs-left' },
    { header: <div>Delivered<Tooltip position='center' trigger={<Icon icon='question' width={16} height={16} customClass='icon-info' />}
      customClasses='idea-status-help-tooltip'
      tooltipMessage={`Ideation statuses that indicate an idea has been delivered (e.g. Delivered, Launched).`} /> </div>,
    accessor: 'delivered',
    size: 'xs-left' },
    { header: <div>Closed<Tooltip position='right' trigger={<Icon icon='question' width={16} height={16} customClass='icon-info' />}
      customClasses='idea-status-help-tooltip'
      tooltipMessage={`Ideation statuses that indicate an idea won't be delivered (e.g. Duplicate, Closed).`} /> </div>,
    accessor: 'closed',
    size: 'xs-left' }
  ]
  const rows = list.map((item, idx) => IdeaStatusMappingRow({ item, idx, onChangeCallback }))
  let unmappedIdeaStatusIds : Array<number> = []
  if (showError) {
    list.forEach(item => {
      if (item.type === '') {
        unmappedIdeaStatusIds.push(Number(item.id))
      }
    })
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className='idea-status-mapping-modal'>
        <h3 className='modal-title'>{modalTitle}</h3>
        <div className='modal-description'>
          <div className='idea-status-mapping-description'>{modalDescription}</div>
          <div className='idea-status-mapping-table'>
            <Table staticWidth model={model} rows={rows} rowId='id' selectedRows={unmappedIdeaStatusIds} isActionBarVisible={false} />
          </div>
          {showError && <div className='idea-status-error-message'> Please choose a type for all idea statuses above. </div>}
        </div>
        <ButtonControl size='medium' variant='success' newStyle title='Save changes' onClick={onSave} />
        <ButtonControl newStyle size='medium' title='Cancel' onClick={onClose} />
      </div>
    </Modal>
  )
}

const statusMapping = (type: string) => {
  const types = ['open', 'delivered', 'closed']
  if (type === '') {
    return ''
  }
  const res = types.find(element => element.includes(type))
  if (res === undefined) {
    return types[0]
  }
  return res
}

interface RowProps {
   item: IdeaStatus,
   idx: number,
   onChangeCallback: (item: IdeaStatus, status: string) => void
}

const IdeaStatusMappingRow = ({ item, idx, onChangeCallback }: RowProps) => {
  const statusStyle = {
    background: item.backgroundColor,
    color: item.textColor
  }
  return ({
    id: Number(item.id),
    status: (
      <div>
        <span style={statusStyle} className='idea-status-label'>{ item.name }</span>
      </div>
    ),
    open: (
      <div>
        <RadioInputGroup hideOptionLabel name={`type-${idx}`} options={['open']} onClick={() => onChangeCallback(item, 'open')} value={statusMapping(item.type)} />
      </div>
    ),
    closed: (
      <div>
        <RadioInputGroup hideOptionLabel name={`type-${idx}`} options={['closed']} onClick={() => onChangeCallback(item, 'closed')} value={statusMapping(item.type)} />
      </div>
    ),
    delivered: (
      <div>
        <RadioInputGroup hideOptionLabel name={`type-${idx}`} options={['delivered']} onClick={() => onChangeCallback(item, 'delivered')} value={statusMapping(item.type)} />
      </div>
    )
  })
}
